// web/src/screens/ConfirmedScreen.jsx
import { useNav } from '../App';

export default function ConfirmedScreen() {
  const { params, navigate } = useNav();
  const { table, lines = [] } = params;

  const steps = [
    { label: 'Order Received',   done: true  },
    { label: 'In Kitchen / Bar', done: false },
    { label: 'Ready to Serve',   done: false },
    { label: 'Served',           done: false },
  ];

  return (
    <div style={s.container}>
      <div style={s.header}>
        <button style={s.backBtn} onClick={() => navigate('tables')}>← TABLES</button>
        <span style={s.title}>ORDER CONFIRMED</span>
        <span />
      </div>

      <div style={s.body}>
        <p style={s.tableName}>✅ {table?.name}</p>
        <p style={s.subtitle}>Order sent · Kitchen notified via WhatsApp</p>

        {/* Status timeline */}
        <div style={s.timeline}>
          {steps.map((step, i) => (
            <div key={i} style={s.step}>
              <div style={{
                ...s.stepDot,
                background:  step.done ? 'var(--orange)' : 'var(--surface-2)',
                borderColor: step.done ? 'var(--orange)' : 'var(--border)',
              }}>
                {step.done ? '✓' : i + 1}
              </div>
              <span style={{ color: step.done ? 'var(--text)' : 'var(--text-dim)', fontSize: 16, fontWeight: step.done ? 700 : 400 }}>
                {step.label}
              </span>
            </div>
          ))}
        </div>

        {/* Order summary */}
        {lines.length > 0 && (
          <div style={s.summary}>
            <p style={s.summaryLabel}>ORDER SUMMARY</p>
            {lines.map((l, i) => (
              <div key={i} style={s.summaryRow}>
                <span style={{ color: 'var(--text)', fontSize: 14 }}>{l.qty}× {l.name}</span>
                <span style={{ color: 'var(--text-muted)', fontSize: 14 }}>KES {(l.price * l.qty).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}

        <button style={s.btn} onClick={() => navigate('myorders')}>VIEW MY ORDERS</button>
        <button style={{ ...s.btn, background: 'var(--surface)', color: 'var(--text)', marginTop: 8 }} onClick={() => navigate('tables')}>
          ← BACK TO TABLES
        </button>
      </div>
    </div>
  );
}

const s = {
  container:    { backgroundColor:'var(--bg)', minHeight:'100vh', color:'var(--text)', fontFamily:"'Barlow Condensed',sans-serif" },
  header:       { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 16px', borderBottom:'1px solid var(--border)' },
  backBtn:      { background:'none', border:'none', color:'var(--orange)', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  title:        { fontSize:18, fontWeight:700, letterSpacing:2 },
  body:         { padding:24 },
  tableName:    { color:'var(--orange)', fontSize:24, fontWeight:700, textAlign:'center', marginBottom:4 },
  subtitle:     { color:'var(--text-muted)', fontSize:14, textAlign:'center', marginBottom:32 },
  timeline:     { marginBottom:32 },
  step:         { display:'flex', alignItems:'center', gap:12, marginBottom:16 },
  stepDot:      { width:32, height:32, borderRadius:'50%', border:'2px solid',
                   display:'flex', alignItems:'center', justifyContent:'center',
                   fontSize:14, fontWeight:700, flexShrink:0 },
  summary:      { background:'var(--surface)', borderRadius:8, padding:16, marginBottom:24 },
  summaryLabel: { color:'var(--text-muted)', fontSize:11, letterSpacing:2, marginBottom:12 },
  summaryRow:   { display:'flex', justifyContent:'space-between', marginBottom:6 },
  btn:          { display:'block', width:'100%', padding:14, background:'var(--orange)', border:'none',
                   borderRadius:8, color:'#fff', fontSize:16, fontWeight:700,
                   cursor:'pointer', fontFamily:'inherit', letterSpacing:1, textAlign:'center' },
};
